import { Card, Col, Row, Space } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from 'utils/formattedString';
import List from 'containers/Orders/List';

const ShowContent = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={[16, 16]}>
      <Col md={6}>
        <Card title={t('users.generalInformation')}>
          <Space size={8} direction="vertical">
            <div>{`${data?.firstName || ''} ${data?.lastName || ''}`}</div>
            <div className="description">{data?.email}</div>
            {data?.telephone && (
              <div className="description">{data?.telephone}</div>
            )}
            <div className="flex-center-between">
              <span>{t('users.createdAt')}</span>
              &nbsp;
              <b>{formatDateTime(data?.createdAt)}</b>
            </div>
          </Space>
        </Card>
      </Col>
      <Col md={18}>
        <Card title={t('users.orders')}>
          {data?.id && <List customerData={data} isShowFixed={true} />}
        </Card>
      </Col>
    </Row>
  );
};

export default ShowContent;
